export const createTrialLink = () => {
  if (typeof window !== 'undefined' && window?.Rewardful?.referral) {
    return `${CONFIG.sciteFrontendURL}${CONFIG.stripe.trialCreationURL}?rewardfulID=${window.Rewardful.referral}`
  }
  return `${CONFIG.sciteFrontendURL}${CONFIG.stripe.trialCreationURL}`
}
